module.exports = __webpack_public_path__ + "static/media/Taq_DNA_Polymerase.713aacfe.svg";